// extracted by mini-css-extract-plugin
export default {"wrapper":"PreloadAnimation-module__wrapper--ea514","animation":"PreloadAnimation-module__animation--b8ab2"};